interface SeoPageOptions {
  title: string
  description: string
  path?: string
  image?: string
  type?: 'website' | 'article'
  publishedAt?: string
}

export function useSeoPage(options: SeoPageOptions) {
  const config = useRuntimeConfig()
  const siteUrl = config.public.siteUrl || 'https://hardiyanto.live'
  const ogImage = options.image || `${siteUrl}/og-image.png`

  useSeoMeta({
    title: options.title,
    description: options.description,
    ogTitle: options.title,
    ogDescription: options.description,
    ogUrl: `${siteUrl}${options.path || ''}`,
    ogType: options.type || 'website',
    ogImage,
    twitterCard: 'summary_large_image',
    twitterTitle: options.title,
    twitterDescription: options.description,
    twitterImage: ogImage,
    ...(options.publishedAt && {
      articlePublishedTime: options.publishedAt
    })
  })
}
